import { updateInstanceChecklist } from '../store.js';
import {
  CHECKLIST_CATEGORY_ORDER,
  checklistCategoryLabel,
} from '../config/checklist-categories.js';
import { escapeHtml } from './dom.js';
import { makeChecklistItemKey } from './plan-checklist.js';
import { patchChecklistItems } from '../trip-context.js';
import { trapModalHistory } from './modal-history.js';

let modalEl = null;
let dismissHistory = null;

function destroyModal() {
  modalEl?.remove();
  modalEl = null;
}

function destroyModalFromBack() {
  dismissHistory = null;
  destroyModal();
}

function closeModal() {
  const dismiss = dismissHistory;
  dismissHistory = null;
  if (dismiss) dismiss();
  else destroyModal();
}

function renderCategoryOptions(selected = 'altro') {
  return CHECKLIST_CATEGORY_ORDER.map(
    (cat) =>
      `<option value="${escapeHtml(cat)}"${cat === selected ? ' selected' : ''}>${escapeHtml(checklistCategoryLabel(cat))}</option>`,
  ).join('');
}

/**
 * @param {object} opts
 * @param {string} opts.instanceId
 * @param {Array<{ itemKey: string, label: string, category?: string }>} opts.checklistItems
 * @param {() => void} [opts.onSuccess]
 */
export function openChecklistAddModal({ instanceId, checklistItems, onSuccess }) {
  closeModal();

  modalEl = document.createElement('div');
  modalEl.className = 'checklist-add-modal';
  modalEl.innerHTML = `
    <div class="checklist-add-modal__backdrop" data-close-checklist-add></div>
    <div class="checklist-add-modal__panel" role="dialog" aria-labelledby="checklist-add-title" aria-modal="true">
      <header class="checklist-add-modal__head">
        <h2 class="checklist-add-modal__title" id="checklist-add-title">Aggiungi alla lista</h2>
        <button type="button" class="btn-ghost btn-ghost--sm" data-close-checklist-add aria-label="Chiudi">Chiudi</button>
      </header>
      <p class="checklist-add-modal__hint">Cosa devi portare o preparare prima di partire?</p>
      <form class="custom-form" id="checklist-add-form">
        <label class="field">
          <span class="field-label">Voce</span>
          <input
            class="field-input"
            name="label"
            required
            maxlength="200"
            placeholder="es. Power bank, pranzo al sacco…"
            autocomplete="off"
          />
        </label>
        <label class="field">
          <span class="field-label">Sezione</span>
          <select class="field-input" name="category" required>
            ${renderCategoryOptions('altro')}
          </select>
        </label>
        <p class="checklist-add-modal__status" id="checklist-add-status" hidden></p>
        <div class="custom-form__actions">
          <button type="submit" class="btn-primary">Aggiungi</button>
          <button type="button" class="btn-ghost" data-close-checklist-add>Annulla</button>
        </div>
      </form>
    </div>
  `;

  document.body.appendChild(modalEl);
  dismissHistory = trapModalHistory(destroyModalFromBack);

  modalEl.querySelectorAll('[data-close-checklist-add]').forEach((el) => {
    el.addEventListener('click', closeModal);
  });

  const form = modalEl.querySelector('#checklist-add-form');
  const status = modalEl.querySelector('#checklist-add-status');
  const labelInput = form.querySelector('[name="label"]');
  labelInput.focus();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const fd = new FormData(form);
    const label = String(fd.get('label')).trim();
    const category = String(fd.get('category') ?? 'altro');
    if (!label) {
      labelInput.focus();
      return;
    }

    const submitBtn = form.querySelector('[type="submit"]');
    submitBtn.disabled = true;
    status.hidden = false;
    status.textContent = 'Salvataggio…';
    status.className = 'checklist-add-modal__status';

    const next = [
      ...checklistItems,
      { itemKey: makeChecklistItemKey(), label, category },
    ];

    try {
      const updated = await updateInstanceChecklist(instanceId, next);
      patchChecklistItems(next, updated);
      status.textContent = 'Voce aggiunta';
      status.className = 'checklist-add-modal__status checklist-add-modal__status--ok';
      onSuccess?.();
      setTimeout(closeModal, 280);
    } catch (error) {
      status.textContent = error.message;
      status.className = 'checklist-add-modal__status checklist-add-modal__status--err';
      submitBtn.disabled = false;
    }
  });
}
